import React from 'react';
import { Carousel, CarouselItem } from '@americanexpress/dls-react';
import {
  useLoungeDetailsCarouselImages,
  useLoungeById,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { cn } from '@/helpers/utils';
import styles from './LoungeDetails.module.scss';

const LoungeDetailsHeroCarousel = () => {
  const { loungeId } = useRouteParams();
  const lounge = useLoungeById(loungeId);
  const images = useLoungeDetailsCarouselImages(loungeId);

  return (
    <div
      id={styles.loungeHeroCarousel}
      className={cn(
        'width-full container lg_tw-mt-10',
        styles.maxWidthMatchHeader
      )}
    >
      <Carousel
        id="lounge-hero"
        isNavigationOnSlides={true}
        shouldAutoPlay={true}
        // onSlideChange={() => {}}
        // autoplay={true}
        // autoplayInterval={2000}
        // TODO add a11y labels to intl for nextButtonLabel, previousButtonLabel
        // https://design.americanexpress.com/language/react/?path=/docs/components-carousel--carousel
        isSlideFullWidth={true}
      >
        {images.map(({ imgUrl, imgId }, i) => (
          <CarouselItem
            key={imgId}
            id={imgId}
            className="tw-aspect-carouselSmall tw-w-full tw-min-w-full sm_tw-aspect-carouselBig"
          >
            <img
              src={imgUrl}
              alt={`#${i + 1} of ${images.length} images of ${lounge.name}`}
              className="tw-w-full tw-object-cover"
            />
          </CarouselItem>
        ))}
      </Carousel>
    </div>
  );
};

export default LoungeDetailsHeroCarousel;
